module.exports = __webpack_public_path__ + "img/moneymex_list_dimg.89a2bb78.webp";